const $ = require('jquery');


let loaderCount = 0;

function checkShowLoader() {
    if (loaderCount > 0) {
        $('#loader').addClass('is-active');
    } else {
        $('#loader').removeClass('is-active');
    }
}

const Loader = {
    show: function() {
        loaderCount++;
        checkShowLoader();
    },
    hide: function() {
        if (loaderCount > 0) {
            loaderCount--;
        }
        checkShowLoader();
    }
};

module.exports = Loader;



// WEBPACK FOOTER //
// ./resources/assets/js/loader.js